var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardSideMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5636 3.2738C10.5636 2.9632 10.3119 2.7113 10.0011 2.7113H4.31982C4.00904 2.7113 3.75732 2.9632 3.75732 3.2738V17.8426C3.75732 18.1533 4.00904 18.4051 4.31982 18.4051H10.0011C10.3119 18.4051 10.5636 18.1533 10.5636 17.8426V3.2738ZM4.88232 3.8363H9.43857V17.3363H4.88232V3.8363Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6765 8.95471C19.6765 8.64411 19.4247 8.39221 19.114 8.39221H13.939C13.6282 8.39221 13.3765 8.64411 13.3765 8.95471V17.8984C13.3765 18.2092 13.6282 18.4609 13.939 18.4609H19.114C19.4247 18.4609 19.6765 18.2092 19.6765 17.8984V8.95471ZM14.5015 9.51721H18.5515V17.3359H14.5015V9.51721Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6577 19.9235H1.28272C0.971934 19.9235 0.720215 20.1754 0.720215 20.486C0.720215 20.7967 0.971934 21.0485 1.28272 21.0485H22.6577C22.9685 21.0485 23.2202 20.7967 23.2202 20.486C23.2202 20.1754 22.9685 19.9235 22.6577 19.9235Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSideMenu);
export default __webpack_public_path__ + "static/media/DashboardSideMenu.48abdc2728de8d5e478be37b04ad3d97.svg";
export { ForwardRef as ReactComponent };